import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Link,
  Text,
} from "@fluentui/react-components";
import { Dismiss24Regular, InfoRegular } from "@fluentui/react-icons";
import { MICROPHONE_HELP_URL } from "apps/diagnostics/externalDiagnostics/externalDiagnosticsConsent/externalDiagnosticsConsent";
import { useMicrophoneHelpDialogStyles } from "./MicrophoneHelpDialog.styles";

export const MicrophoneHelpDialog = (): JSX.Element => {
  const BUTTON_TITLE: string = "Microphone help";
  const styles = useMicrophoneHelpDialogStyles();

  return (
    <Dialog>
      <DialogTrigger disableButtonEnhancement>
        <Button
          aria-label={BUTTON_TITLE}
          title={BUTTON_TITLE}
          icon={<InfoRegular />}
          appearance={"subtle"}
          shape={"circular"}
          size={"small"}
        />
      </DialogTrigger>

      <DialogSurface
        aria-label="Microphone Access Help"
        className={styles.surface}
      >
        <DialogBody>
          <DialogTrigger action="close" disableButtonEnhancement>
            <Button
              aria-label="Close"
              icon={<Dismiss24Regular />}
              appearance="subtle"
              className={styles.closeButton}
            />
          </DialogTrigger>
          <DialogTitle className={styles.title}>
            Microphone Access Required
          </DialogTitle>
          <DialogContent className={styles.content}>
            <div className={styles.grid}>
              <Text>
                <b>Desktop/Laptop:</b> Click &quot;Allow&quot; in the browser
                permission popup. Select your preferred microphone if you have
                multiple devices.
              </Text>
              <Text>
                <b>Mobile Devices:</b> Tap &quot;Allow&quot; when prompted.
                Ensure the site has microphone permissions in your device
                settings.
              </Text>
              <Text>
                <b>Troubleshooting:</b> If no sound is detected, check your
                browser settings or device permissions.
              </Text>
              <Text>
                <Link
                  href={MICROPHONE_HELP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click here for more details.
                </Link>
              </Text>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
